import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";

export default function BankingAnalytics() {
  const allData = [
    { id: "BANK250925", fileName: "Statement Q1", date: "24 Sep, 2025" },
    { id: "BANK250924", fileName: "Statement Q2", date: "20 Sep, 2025" },
    { id: "BANK250923", fileName: "Statement Q3", date: "15 Sep, 2025" },
  ];

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(2);
  const totalPages = Math.ceil(allData.length / rowsPerPage);
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentData = allData.slice(indexOfFirst, indexOfLast);

  const handleNext = () =>
    currentPage < totalPages && setCurrentPage(currentPage + 1);
  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleRowsChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [bank, setBank] = useState("");
  const [details, setDetails] = useState("");
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const allowedTypes = [
        "application/pdf",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (!allowedTypes.includes(selectedFile.type)) {
        alert("Only PDF or Excel files are allowed!");
        e.target.value = null;
        return;
      }
      setFile(selectedFile);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Bank:", bank);
    console.log("Details:", details);
    console.log("File:", file?.name || "No file selected");
    setShowModal(false);
    setBank("");
    setDetails("");
    setFile(null);
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>
          <div className="card shadow-sm p-4 mb-4">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4">
              <h3 className="text-primary mb-2">Banking Analytics</h3>
              <button
                className="btn btn-primary"
                onClick={() => setShowModal(true)}
              >
                Get Banking Analytics
              </button>
            </div>
            {/* Header */}
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>

                <li className="breadcrumb-item active" aria-current="page">
                  Get Banking Analytics
                </li>
              </ol>
            </nav>
          
          </div>

          <div className="card shadow-sm p-4 mb-4">
            {/* Table */}
            <div className="table-responsive">
              <table className="table table-bordered align-middle text-center">
                <thead style={{ backgroundColor: "#FFE6DC" }}>
                  <tr>
                    <th>Sr.No.</th>
                    <th>File Name</th>
                    <th>Bank Name</th>
                    <th>Period</th>
                    <th>Account Type</th>
                    <th>Fetched Date & Time</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((item, index) => (
                    <tr key={item.id}>
                      <td className="text-primary fw-semibold">{item.id}</td>
                      <td>{item.fileName}</td>
                      <td>HDFC</td>
                      <td>Q1 2025</td>
                      <td>Current</td>
                      <td>{item.date}</td>
                      <td>
                        <span
                          className="badge rounded-pill"
                          style={{
                            backgroundColor: "#ff6600",
                            color: "#fff",
                            fontSize: "0.9rem",
                            padding: "8px 16px",
                          }}
                        >
                          Pending
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="d-flex justify-content-between align-items-center mt-4">
              <div>
                <select
                  className="form-select d-inline-block"
                  style={{ width: "80px" }}
                  value={rowsPerPage}
                  onChange={handleRowsChange}
                >
                  <option value={2}>2</option>
                  <option value={4}>4</option>
                  <option value={6}>6</option>
                </select>
              </div>

              <div className="d-flex align-items-center">
                <button
                  className="btn btn-primary me-2"
                  onClick={handlePrev}
                  disabled={currentPage === 1}
                >
                  &laquo;
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  style={{ borderRadius: "50%", width: "36px", height: "36px" }}
                >
                  {currentPage}
                </button>
                <button
                  className="btn btn-primary ms-2"
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                >
                  &raquo;
                </button>
              </div>

              <div>
                <span>
                  {indexOfFirst + 1} - {Math.min(indexOfLast, allData.length)}{" "}
                  of {allData.length}
                </span>
              </div>
            </div>

            <div className="mt-4">
              <Link to="/clientloan" className="text-decoration-none text-dark">
                <button className="btn btn-primary px-4">Back</button>
              </Link>
            </div>
          </div>
        </div>
    

      {/* Popup Modal */}
      {showModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}
        >
          <div
            className="bg-white p-4 rounded shadow"
            style={{ width: "400px" }}
          >
            <h5 className="mb-3 text-center">Banking Analytics Details</h5>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label fw-semibold">Select Bank</label>
                <select
                  className="form-select"
                  value={bank}
                  onChange={(e) => setBank(e.target.value)}
                  required
                >
                  <option value="">-- Choose Bank --</option>
                  <option value="HDFC">HDFC</option>
                  <option value="ICICI">ICICI</option>
                  <option value="SBI">SBI</option>
                  <option value="Axis">Axis</option>
                  <option value="Kotak">Kotak</option>
                </select>
              </div>

              {/* <div className="mb-3">
                <label className="form-label fw-semibold">Bank Details</label>
                <textarea
                  className="form-control"
                  rows="4"
                  value={details}
                  onChange={(e) => setDetails(e.target.value)}
                  placeholder="Enter details here..."
                  required
                ></textarea>
              </div> */}

              {/* Show File Upload only if bank is selected */}
              {bank && (
                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Upload Bank File
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={handleFileChange}
                    accept=".pdf, .xls, .xlsx"
                  />
                  {file && (
                    <small className="text-success mt-1 d-block">
                      Selected File: {file.name}
                    </small>
                  )}
                </div>
              )}

              <div className="d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
